import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "wo-ferryman-list"
};
const _hoisted_2 = {
  key: 1,
  class: "item-card-grid-view"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "info-container"
};
const _hoisted_5 = {
  class: "main-text"
};
const _hoisted_6 = {
  class: "second-text"
};
const _hoisted_7 = {
  key: 2,
  class: "empty-data-tips"
};
const _hoisted_8 = {
  key: 3,
  class: "pagination-container"
};
import { onMounted, ref, computed } from 'vue';
import { request } from '@/manager/net_manager';
import { ElIcon, ElImage } from 'element-plus';
import store from "@/store";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import FerrymanGenerator from "@/components/WorldOutlook/FerrymanGenerator.vue";
import { inApostleType, isAdminType } from "@/tools/utils";
import { Plus } from "@element-plus/icons-vue"; // refs

export default {
  __name: 'WOFerryman',

  setup(__props) {
    const dataArray = ref([]);
    const pagerCount = ref(5);
    const size = ref(10);
    const total = ref(0);
    const page = ref(0);
    const selectedData = ref(null); // computed

    const worldOutlook = computed(() => store.state.world_outlook);
    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4); // functions

    const getData = () => {
      if (worldOutlook.value !== null) {
        const parameters = {
          'world_outlook_id': worldOutlook.value.id,
          'page': page.value,
          'size': size.value
        };
        request('ferryman/list/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            dataArray.value = response.data.data_array;
            total.value = response.data.numbers;
          }
        });
      }
    };

    const handlePageChange = index => {
      page.value = index - 1;
      getData();
    };

    const clickItem = item => {
      if (isAdminType(userType.value)) {
        selectedData.value = item;
      }
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      const _component_el_row = _resolveComponent("el-row");

      const _component_el_pagination = _resolveComponent("el-pagination");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_unref(isAdminType)(userType.value) ? (_openBlock(), _createBlock(_component_el_row, {
        key: 0,
        style: {
          "width": "100%",
          "justify-content": "flex-end"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "create-ferryman",
          onClick: _cache[0] || (_cache[0] = $event => selectedData.value = {})
        }, [_createVNode(_unref(ElIcon), {
          size: "12",
          style: {
            "margin-right": "6px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_unref(Plus))]),
          _: 1
        }), _cache[3] || (_cache[3] = _createElementVNode("text", null, "创建舟子", -1))])]),
        _: 1
      })) : _createCommentVNode("", true), dataArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-card",
          onClick: $event => clickItem(item)
        }, [_createVNode(_unref(ElImage), {
          src: item.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("text", _hoisted_5, _toDisplayString(item.nickname), 1), _createElementVNode("text", _hoisted_6, _toDisplayString(item.biography), 1)])], 8, _hoisted_3);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [_createElementVNode("text", {
        style: {
          "display": "flex"
        }
      }, "未发现舟子数据", -1)]))])), total.value > size.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_pagination, {
        "page-size": size.value,
        "pager-count": pagerCount.value,
        layout: "prev, pager, next",
        total: total.value,
        background: true,
        onChange: handlePageChange
      }, null, 8, ["page-size", "pager-count", "total"])])) : _createCommentVNode("", true)]), selectedData.value !== null && _unref(inApostleType)(userType.value) ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 0,
        onClose: _cache[2] || (_cache[2] = $event => selectedData.value = null)
      }, {
        default: _withCtx(() => [_createVNode(FerrymanGenerator, {
          data: selectedData.value,
          onClose: _cache[1] || (_cache[1] = $event => {
            selectedData.value = null;
            getData();
          })
        }, null, 8, ["data"])]),
        _: 1
      })) : _createCommentVNode("", true)], 64);
    };
  }

};